import React from "react";
import { S3 } from "../../../constants";
import { hexToRGBA } from "../../../utils/colors";

const isPng = (fileName = "") => fileName.match(/.(png)$/i);

const srcIsPng = (src = "") => src.match(/(image\/png)/i);

const LogoOverlayComponent = ({
  opacity,
  overlayColor,
  withOverlay,
  withLogo,
  logo,
  isTinted,
  splashLogoSrc,
  buildAppPreview,
}) => {
  const color = hexToRGBA(overlayColor, opacity / 100);

  const logoSrc = splashLogoSrc
    ? splashLogoSrc
    : logo && logo.s3Path
    ? `${S3.PATH}${logo.s3Path}`
    : buildAppPreview
    ? "/img/svg/MSB_powered_by-light.svg"
    : "/img/new-icons/MSB-full-logo-extended.svg";
  const tintable = splashLogoSrc
    ? !!srcIsPng(splashLogoSrc)
    : !!(logo && logo.name && isPng(logo.name));

  return (
    <>
      {withOverlay && (
        <div className="splash-bg-overlay" style={{ background: color }} />
      )}
      {withLogo && (
        <div
          className={`splash-bg-overlay-logo${
            isTinted && tintable ? " tinted" : ""
          }`}
          src={logoSrc}
          style={{ backgroundImage: `url(${logoSrc})` }}
        />
      )}
    </>
  );
};

export default LogoOverlayComponent;
